import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataResult } from '@progress/kendo-data-query';
import { AppConstant } from 'src/app/app.constant';
import { DataToDelete } from 'src/app/_metronic/core/classes/core.class';
import { ToasterService, ToasterType } from 'src/app/services/toaster/toaster.service';

@Injectable()
export class TransportationService {
    apiUrl: string;
    kendoDataUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant,private toasterService: ToasterService,) {
        this.apiUrl = this.appConstant.getUrl();
        this.kendoDataUrl = this.apiUrl + 'GetAll';
    }

    // Bus
    manageBus(bus) {
        return this.httpClient.post(`${this.apiUrl}/manageBus`, bus).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getBusById(Id) {
        return this.httpClient.get(`${this.apiUrl}/getBusById/`+ Id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllBusKendo(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllBus`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    async getAllBusName() : Promise<any[]> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllBusName/`).toPromise()).data;
    }

    getAllBusExcel() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/downloadExcelBus`).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    deleteMultipleBus(busesIdNameList: Array<DataToDelete> = []) {
        return this.httpClient.post(`${this.apiUrl}/bulkDeleteBus/`, {
            DataToDelete: busesIdNameList
        }).pipe(
            map((response: any) => {
                return response;
            }))
    }

    // bus stopes 
    manageBusStop(bus) {
        return this.httpClient.post(`${this.apiUrl}/manageBusStops`, bus).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
 
    getBusStopById(Id) {
        return this.httpClient.get(`${this.apiUrl}/getBusStopById/`+ Id).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    public getAllBusStopKendo(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllBusStops`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    async getAllBusStopName() : Promise<any[]> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllBusStopsName/`).toPromise()).data;
    }

    getAllBusStopExcel() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/downloadExcelBusStops`).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    deleteMultipleBusStop(busesIdNameList: Array<DataToDelete> = []) {
        return this.httpClient.post(`${this.apiUrl}/bulkDeleteBusStops/`, {
            DataToDelete: busesIdNameList
        }).pipe(
            map((response: any) => {
                return response;
            }))
    }

    bulkAddTransporationFees(feeData) {
        return this.httpClient.post(`${this.apiUrl}/bulkAddTransportFees/`, feeData).pipe(
            map((response: any) => {
                return response;
            })
        )
    }

    getAllTransportationFees(filters): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllTransportFees/`, filters).pipe(
            map((response: any) => {
                return response.data;
            })
        )
    }

    // transport fee collection
    getAllTransportFeesByStudent(id) {
        return this.httpClient.get(`${this.apiUrl}/getAllTransportFeesByStudent/` + id).pipe(
          map((response: any) => {
            return response;
          })
        )
    }
    collectStudentTransportFees(data) {        
        return this.httpClient.post(`${this.apiUrl}/collectStudentTransportFees/`, data).pipe(
          map((response: any) => {
            return response;
          })
        )
      }
    
    async getAllTransportFeesReceipt(Id): Promise<any> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllTransportFeesReceipt/` + Id).toPromise()).data;
    }
    
    public downloadTransportFeesReceipt(Id) {
        return new Promise((resolve, reject) => {
          this.httpClient.get(`${this.apiUrl}/downloadTransportFeesReceipt/` + Id, { responseType: 'blob' }).pipe(
            map(res => res))
            .subscribe(res => {
              resolve(res);
            }, (err) => {
              if (err.status == 403) {
                this.toasterService.showToaster(null, "No data found!", ToasterType.Error)
              }
              reject(err);
            });
        });
    }
    public downloadTransportFeesPaymentInvoice(Id) {
        return new Promise((resolve, reject) => {
          this.httpClient.get(`${this.apiUrl}/downloadTransportFeesPaymentInvoice/` + Id, { responseType: 'blob' }).pipe(
            map(res => res))
            .subscribe(res => {
              resolve(res);
            }, (err) => {
              if (err.status == 403) {
                this.toasterService.showToaster(null, "No data found!", ToasterType.Error)
              }
              reject(err);
            });
        });
      }
    
    
    async getTransportFeesReceiptData(Id): Promise<any> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getTransportFeesReceiptData/` + Id).toPromise()).data;
    }
    
    bulkDeleteTransportFeesReceipt(data) {
        return this.httpClient.post(`${this.apiUrl}/bulkCancelTransportFeesReceipt/`, data).pipe(
          map((response: any) => {
            return response;
          })
        )
    }
    
    bulkRevertTransportCancelFeesReceipt(data) {
        return this.httpClient.post(`${this.apiUrl}/bulkRevertCancelTransportFeesReceipt/`, data).pipe(
          map((response: any) => {
            return response;
          })
        )
    }
    updateTransportFeesInvoiceDate(req) {
        return this.httpClient.post(`${this.apiUrl}/updateTransportFeesInvoiceDate`, req).map((response: any) => {
          return response;
        })
    }

    bulkCancelStudentTransportFees(data) {
        return this.httpClient.post(`${this.apiUrl}/bulkCancelStudentTransportFees/`, data).pipe(
          map((response: any) => {
            return response;
          })
        )
    }

    manageTransportFeesConfig(data) {
        return this.httpClient.post(`${this.apiUrl}/ManageTransportFeesReceiptConfig`, data).pipe(
          map((response: any) => {
            return response;
          })
        )
      }
    
    getAllTransportFeesConfig() {
        return this.httpClient.get(`${this.apiUrl}/GetAllTransportFeesReceiptConfig/`).pipe(
          map((response: any) => {
            return response;
          })
        )
      }
    
    GetTransporterSetting() {
        return this.httpClient.get(`${this.apiUrl}/GetTransporterSetting`).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
    
    ManageTransporterSetting(data) {          
        return this.httpClient.post(`${this.apiUrl}/ManageTransporterSetting`, data).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
}
